import { createQuery } from '../../libs';
import { CommunicationLanguagesResponse } from './models';

export const useGetCommunicationLanguages = createQuery<CommunicationLanguagesResponse>({
  method: 'get',
  url: 'communication-languages',
});
